import React from 'react';
import {StyleSheet, Text, TouchableOpacity, View, Image} from 'react-native';
import {WINDOW_WIDTH} from "../../Config/Constants";
import {BORDER_COLOR, HEADER_TITLE_COLOR} from "../../Config/Colors";
import OnIcon from '../../Images/Icons/on.png';
import OffIcon from '../../Images/Icons/off.png';
import RefreshIcon from '../../Images/Icons/refresh.png';

interface ListFooterProps
{
    /**
     * Show the footer only. Hide all the other content.
     */
    showFooterOnly?: boolean;
    
    /**
     * Callback when the wake option has been selected.
     */
    onWakePressed?: () => void;

    /**
     * Callback when shutdown was pressed.
     */
    onShutdownPressed?: () => void;

    /**
     * The total selected items.
     */
    totalSelectedItems?: number;

    /**
     * Total items.
     */
    totalItems?: number;

    /**
     * Callback when the refresh button has been pressed.
     */
    onRefreshPressed?: () => void;
}

/**
 * Renders the List Footer.
 */
export default function ListFooter({
    showFooterOnly = false,
    onWakePressed,
    onShutdownPressed,
    onRefreshPressed,
    totalSelectedItems = 0,
    totalItems = 0,
}: ListFooterProps)
{
    return (
        <View style={styles.container}>
            <View style={styles.refreshButtonView}>
                <TouchableOpacity
                    style={[styles.buttonView, {
                        justifyContent: 'flex-end',
                        height: '100%',
                    }]}
                    onPress={onRefreshPressed}
                >
                    <View style={styles.divider}/>

                    <Image
                        source={RefreshIcon}
                        resizeMode={"contain"}
                        style={[styles.icon, {
                            height: '40%',
                            marginLeft: '6%',
                        }]}
                    />

                    <Text style={styles.buttonText}>
                        Force Refresh
                    </Text>
                    
                </TouchableOpacity>
            </View>
            
            {!showFooterOnly && (
                <>
                    <View style={styles.totalSelectedView}>
                        <Text style={[styles.buttonText, {
                            textTransform: 'none',
                        }]}>
                            {`[${totalSelectedItems} / ${totalItems} Clients Selected]`}
                        </Text>
                    </View>
                    
                    <View style={styles.itemView}>
                        <TouchableOpacity
                            style={styles.buttonView}
                            onPress={onWakePressed}
                        >
                            <Image
                                source={OnIcon}
                                resizeMode={"contain"}
                                style={styles.icon}
                            />
    
                            <Text style={styles.buttonText}>
                                {`Wake Selected`}
                            </Text>
                        </TouchableOpacity>
                    </View>
    
                    <View style={styles.divider}/>
    
                    <View style={styles.itemView}>
                        <TouchableOpacity
                            style={styles.buttonView}
                            onPress={onShutdownPressed}
                        >
                            <Image
                                source={OffIcon}
                                resizeMode={"contain"}
                                style={styles.icon}
                            />
    
                            <Text style={styles.buttonText}>
                                {`Shutdown Selected`}
                            </Text>
                        </TouchableOpacity>
                    </View>
                </>
            )}
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
        flex: 0.085,
        borderColor: 'transparent',
        borderWidth: 4,
        borderTopColor: BORDER_COLOR,
    },
    totalSelectedView: {
        position: 'absolute',
        left: 0,
        alignSelf: 'center',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    },
    itemView: {
        alignItems: 'center',
        justifyContent: 'center',
        width: '18%',
    },
    refreshButtonView: {
        position: 'absolute',
        right: 0,
        width: '20%',
        height: '100%',
        justifyContent: 'center',
    },
    divider: {
        width: WINDOW_WIDTH * 0.001,
        height: '50%',
        backgroundColor: HEADER_TITLE_COLOR,
        marginHorizontal: '0.5%',
        alignSelf: 'center',
        opacity: 0.5,
    },
    buttonView: {
        flexDirection: 'row',
        width: '100%',
        height: '70%',
        backgroundColor: 'transparent',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: WINDOW_WIDTH * 0.05,
    },
    buttonText: {
        textAlign: 'center',
        alignItems: 'center',
        textTransform: "capitalize",
        fontWeight: "700",
        color: HEADER_TITLE_COLOR,
        fontSize: WINDOW_WIDTH * 0.011,
    },
    icon: {
        width: undefined,
        height: '80%',
        aspectRatio: 1,
        marginRight: '2%',
    },
});
